// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/carousel-article-list/carousel-article-list.component.scss
// module id = 364
// module chunks = 0